type getPostsSliceProps = {
  paginationLimit: number
  range: number
  pagesCount: number
  cursorInList: number
}

export const getPostsSlice = ({ paginationLimit, range, pagesCount, cursorInList }: getPostsSliceProps) => {
  // Generate array of keys
  // 5 -> [0, 1, 2, 3, 4]
  const arrayOfKeys = Array.from(Array(pagesCount).keys())

  const moveRange = cursorInList > pagesCount - range ? pagesCount - range : cursorInList

  // if pagesCount is not more then paginationLimit use from 0 to paginationLimit range
  const startElement = pagesCount > paginationLimit ? moveRange : 0
  const stopElement = pagesCount > paginationLimit ? cursorInList + range : paginationLimit

  const items = arrayOfKeys.slice(startElement, stopElement)
  const lastElementIndex = items[items.length - 1]

  // show last item only if this item not in the list
  const showLastItem = lastElementIndex + 1 !== pagesCount

  // show dots only if there is 3 more items before last item
  const showDots = pagesCount - lastElementIndex + 1 > 3
  const showPenultimateItem = pagesCount - 2 === lastElementIndex + 1

  return { items, showLastItem, showDots, showPenultimateItem }
}
